import { createContext } from "react";
import { DashboardActions } from "../DashboardProvider.types";

const DashboardActionsContext = createContext<DashboardActions | undefined>(undefined);
DashboardActionsContext.displayName = "DashboardActionsContext";

export default DashboardActionsContext;
